import moment from 'moment';

/*
 * Rules of a Community product's maintenance in the product form (SYN-3454). A Community machine's base maintenance
 * is the "Community Support" plan. When Operations adds a paid maintenance to it, the product PATCH removes Community
 * Support and the Community licenses and starts the paid maintenance on the day the added row carries (tech spec
 * §6.14, §12.1). `startDate` is accepted on that row only: the route answers 400 for any other row.
 */

export const COMMUNITY_PLAN_TYPE = 'community';
export const COMMUNITY_PLAN_INTERNAL_NAME = 'Community Support';

/*
 * The plan type decides when the server sends one (SYN-3438 adds `planType`); until then the Community plan is known
 * by its name, as the ticket says.
 */
export const isCommunityPlan = (plan) => {
	if (!plan) {
		return false;
	}
	if (plan.planType) {
		return plan.planType === COMMUNITY_PLAN_TYPE;
	}

	return plan.synetoInternalName === COMMUNITY_PLAN_INTERNAL_NAME || plan.customerFacingName === COMMUNITY_PLAN_INTERNAL_NAME;
};

// The base maintenance is the first row Central stored; the form keeps it first and chains renewals after it.
export const isCommunityProduct = (maintenanceServices) => {
	const base = (maintenanceServices || []).find((row) => { return Boolean(row && row.id); });

	return Boolean(base && isCommunityPlan(base.plan));
};

export const isNewMaintenanceRow = (row) => {
	return Boolean(row && !row.id);
};

// The row that becomes the paid maintenance: the first row added to a Community product, or none.
export const findReplacingMaintenance = (maintenanceServices) => {
	if (!isCommunityProduct(maintenanceServices)) {
		return null;
	}

	return (maintenanceServices || []).find(isNewMaintenanceRow) || null;
};

// Calendar days travel at 00:00 UTC, like the grant dates (client/helpers/addonPeriod.js).
export const todayAtUtcMidnight = () => {
	return moment.utc().startOf('day').toISOString();
};

export const dayToUtcMidnight = (day) => {
	if (!day) {
		return null;
	}

	const parsed = moment.utc(day, ['YYYY-MM-DD', moment.ISO_8601], true);

	return parsed.isValid() ? parsed.startOf('day').toISOString() : null;
};

/*
 * The maintenance rows as the product POST or PATCH takes them: no row carries `startDate`, except the row that
 * replaces Community Support, which carries the chosen day, today when none was chosen. The rows of a loaded product
 * carry the start the server computed, and sending it back would be refused.
 */
export const toMaintenancePayload = (maintenanceServices) => {
	const rows = maintenanceServices || [];
	const replacing = findReplacingMaintenance(rows);

	return rows.map((row) => {
		if (!row) {
			return row;
		}

		const { startDate, ...payload } = row;

		if (row === replacing) {
			payload.startDate = startDate || todayAtUtcMidnight();
		}

		return payload;
	});
};
